module.exports = __webpack_public_path__ + "static/parade-2019-house06-c19b6450c09b6c47e9055b00ad32b1bc.jpg";